import { render, staticRenderFns } from "./BadgeStatusOrder.vue?vue&type=template&id=1ca02541&"
import script from "./BadgeStatusOrder.vue?vue&type=script&lang=js&"
export * from "./BadgeStatusOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports